export const mainNav = [{
    title: 'Services',
    target: 'services'
}, {
    title: 'About',
    target: "about"
}, {
    title: 'FAQ',
    target: "faq"
}, {
    title: 'Contact',
    target: "contact"
}]